export const text = {
  delete: "Delete Image",
};
